import ToolTip from "components/design/toolTip";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { subsidiaryDetails } from "types/Models/TaskTracker";

export const CircularFlag = ({ countryCode }: { countryCode: string }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      overflow: "hidden",
      flexShrink: 0,
      position: "relative",
    }}
  >
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      title={countryCode}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </div>
);

export const NoOfSubsidiaries = ({
  subsidiaries,
}: {
  subsidiaries: subsidiaryDetails[];
}) => {
  const subsidiariesArray = Object.entries(
    subsidiaries?.reduce<Record<string, any[]>>((acc, subsidiaries) => {
      acc[subsidiaries.country.code] = acc[subsidiaries.country.code] || [];
      acc[subsidiaries.country.code].push(subsidiaries);
      return acc;
    }, {})
  ).map(([countryCode, subsidiaries]) => ({ countryCode, subsidiaries }));

  const countryCount = subsidiariesArray.length;

  if (countryCount === 0) {
    return "-";
  }

  return (
    <div className="t-flex t-gap-2 t-items-center">
      {subsidiariesArray.slice(0, 3).map(({ countryCode, subsidiaries }) => (
        <ToolTip
          text={
            <div className="t-flex t-flex-col t-gap-2">
              {subsidiaries.map((entity) => (
                <div
                  key={entity.uuid}
                  className="t-flex t-items-center t-gap-1"
                >
                  <CircularFlag countryCode={countryCode} />
                  <span className="t-text-body-sm t-text-surface">
                    {entity.name}
                  </span>
                </div>
              ))}
            </div>
          }
          key={countryCode}
        >
          <div className="t-flex t-gap-1 t-items-center t-px-1.5 t-py-0.5 t-rounded-2xl t-bg-neutral-0">
            <CircularFlag countryCode={countryCode} />
            <span className="t-text-body-sm t-text-neutral-70">
              {subsidiaries.length}
            </span>
          </div>
        </ToolTip>
      ))}
      {countryCount > 3 && (
        <ToolTip
          text={
            <div className="t-flex t-flex-col t-gap-2">
              {subsidiariesArray.slice(3).map(({ countryCode, subsidiaries }) =>
                subsidiaries.map((entity) => (
                  <div
                    key={entity.uuid}
                    className="t-flex t-items-center t-gap-1"
                  >
                    <CircularFlag countryCode={countryCode} />
                    <span className="t-text-body-sm t-text-surface">
                      {entity.name}
                    </span>
                  </div>
                ))
              )}
            </div>
          }
        >
          <span className="t-text-body-sm t-text-neutral-70 t-px-1.5 t-py-0.5 t-rounded-2xl t-bg-neutral-0">
            +{countryCount - 3}
          </span>
        </ToolTip>
      )}
    </div>
  );
};
